import React, { useState } from 'react';
import { X } from 'react-feather';
import { checkFileSize } from '../../../utils/check-file-size'

const disabledStyle =
  'cursor-not-allowed bg-gray-300 text-gray-500 hover:scale-100 hover:bg-gray-300';

const VerifyModal = ({ closeModal, verifyUser }) => {
  const [activeTab, setActiveTab] = useState('passport');

  // passport
  const [passportFile, setPassportFile] = useState(null);
  const isPassportDisabled = passportFile === null;

  //driver license
  const [driverLicenseFrontFile, setDriverLicenseFrontFile] = useState(null);
  const [driverLicenseBackFile, setDriverLicenseBackFile] = useState(null);
  const isDriverLicenseDisabled =
    driverLicenseFrontFile === null || driverLicenseBackFile === null;

  // id card
  const [idCardFrontFile, setIdCardFrontFile] = useState(null);
  const [idCardBackFile, setIdCardBackFile] = useState(null);
  const isIdCardDisabled = idCardFrontFile === null || idCardBackFile === null;

  // student card
  const [studentCardFrontFile, setStudentCardFrontFile] = useState(null);
  const [studentCardBackFile, setStudentCardBackFile] = useState(null);
  const isStudentCardDisabled =
    studentCardFrontFile === null || studentCardBackFile === null;

  const verify = async () => {
    try {
      if (activeTab === 'passport') {
        await verifyUser({ type: 'passport', front: passportFile });
      }
      if (activeTab === 'driverlicense') {
        await verifyUser({
          type: 'driverlicense',
          front: driverLicenseFrontFile,
          back: driverLicenseBackFile,
        });
      }
      if (activeTab === 'id') {
        await verifyUser({
          type: 'idcard',
          front: idCardFrontFile,
          back: idCardBackFile,
        });
      }
      if (activeTab === 'studentcard') {
        await verifyUser({
          type: 'studentcard',
          front: studentCardFrontFile,
          back: studentCardBackFile,
        });
      }

      closeModal();
    } catch (err) {
      console.log(err);
    }
  };

  const wrapperSendFile = (e, func) => {
    try {
      checkFileSize(e);
    } catch (err) {
      return;
    }

    func(e)
  };

  return (
    <section
      className="wallet_modal_wrapper"
      onClick={(e) => {
        e.stopPropagation();
        closeModal();
      }}
    >
      <div
        className="wallet_modal !w-full !justify-normal !max-w-[100%] lg:!max-w-[50%]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="wallet_modal_header">
          <h1 className="wallet_modal_title">Verify your identity</h1>
          <X className="wallet_modal_close" onClick={closeModal} />
        </div>
        <div className="wallet_modal_body h-full !justify-center flex-1">
          <p className="wallet_modal_description">
            You're one step closer! Upload your document to complete
            verification. Secure and fast verification—choose your document type
            to get started.
          </p>
          <div className="flex flex-col sm:flex-row w-full justify-between gap-4">
            <button
              className={`px-4 w-full py-2 border-[4px] border-transparent rounded-full text-base font-medium text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out text-centern ${activeTab === 'passport' ? '!border-green-400 bg-white' : 'bg-slate-400 hover:scale-110 hover:bg-[white]'}`}
              onClick={() => setActiveTab('passport')}
            >
              Passport
            </button>
            <button
              className={`px-4 w-full py-2 border-[4px] border-transparent rounded-full text-base font-medium text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out text-center ${activeTab === 'driverlicense' ? '!border-green-400 bg-white' : 'bg-slate-400 hover:scale-110 hover:bg-[white]'}`}
              onClick={() => setActiveTab('driverlicense')}
            >
              Driver license
            </button>
            <button
              className={`px-4 w-full py-2 border-[4px] border-transparent rounded-full text-base font-medium text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out text-center ${activeTab === 'id' ? '!border-green-400 bg-white' : 'bg-slate-400 hover:scale-110 hover:bg-[white]'}`}
              onClick={() => setActiveTab('id')}
            >
              ID card
            </button>
            <button
              className={`px-4 w-full py-2 border-[4px] border-transparent rounded-full text-base font-medium text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out text-center ${activeTab === 'studentcard' ? '!border-green-400 bg-white' : 'bg-slate-400 hover:scale-110 hover:bg-[white]'}`}
              onClick={() => setActiveTab('studentcard')}
            >
              Student card
            </button>
          </div>
          <div className="wallet_modal_content w-full">
            {activeTab === 'passport' && (
              <div className="tab_content w-full">
                <input
                  type="file"
                  id="filePassport"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => wrapperSendFile(e, (e) => setPassportFile(e.target.files[0]))}
                />
                <div className="flex justify-center gap-4">
                  {passportFile ? (
                    <button
                      onClick={() => setPassportFile(null)}
                      className="mt-4 px-4 py-2 border-none rounded-full text-base font-medium bg-red-600 text-white cursor-pointer transition-all duration-400 ease-in-out hover:scale-110 text-center"
                    >
                      Delete passport
                    </button>
                  ) : (
                    <label
                      htmlFor="filePassport"
                      className="mt-4  px-4 py-2 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center"
                    >
                      Attach Passport
                    </label>
                  )}
                </div>

                <button
                  onClick={verify}
                  disabled={isPassportDisabled}
                  className={`mt-10 w-full px-8 py-6 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center ${isPassportDisabled ? disabledStyle : ''}`}
                >
                  Verify
                </button>
              </div>
            )}
            {activeTab === 'driverlicense' && (
              <div className="tab_content w-full">
                <input
                  type="file"
                  id="fileFrontDriverLicense"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => wrapperSendFile(e, (e) => setDriverLicenseFrontFile(e.target.files[0]))}
                />
                <input
                  type="file"
                  id="fileBackDriverLicense"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => wrapperSendFile(e, (e) => setDriverLicenseBackFile(e.target.files[0]))}
                />
                <div className="flex justify-center gap-4">
                  {driverLicenseFrontFile ? (
                    <button
                      onClick={() => setDriverLicenseFrontFile(null)}
                      className="mt-4 px-4 py-2 border-none rounded-full text-base font-medium bg-red-600 text-white cursor-pointer transition-all duration-400 ease-in-out hover:scale-110 text-center"
                    >
                      Delete driver license front
                    </button>
                  ) : (
                    <label
                      htmlFor="fileFrontDriverLicense"
                      className="mt-4  px-4 py-2 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center"
                    >
                      Attach Driver license front
                    </label>
                  )}

                  {driverLicenseBackFile ? (
                    <button
                      onClick={() => setDriverLicenseBackFile(null)}
                      className="mt-4 px-4 py-2 border-none rounded-full text-base font-medium bg-red-600 text-white cursor-pointer transition-all duration-400 ease-in-out hover:scale-110 text-center"
                    >
                      Delete driver license back
                    </button>
                  ) : (
                    <label
                      htmlFor="fileBackDriverLicense"
                      className="mt-4  px-4 py-2 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center"
                    >
                      Attach Driver license back
                    </label>
                  )}
                </div>

                <button
                  onClick={verify}
                  disabled={isDriverLicenseDisabled}
                  className={`mt-10 w-full px-8 py-6 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center ${isDriverLicenseDisabled ? disabledStyle : ''}`}
                >
                  Verify
                </button>
              </div>
            )}
            {activeTab === 'id' && (
              <div className="tab_content w-full">
                <input
                  type="file"
                  id="fileFrontId"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => wrapperSendFile(e, (e) => setIdCardFrontFile(e.target.files[0]))}
                />
                <input
                  type="file"
                  id="fileBackId"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => wrapperSendFile(e, (e) => setIdCardBackFile(e.target.files[0]))}
                />
                <div className="flex justify-center gap-4">
                  {idCardFrontFile ? (
                    <button
                      onClick={() => setIdCardFrontFile(null)}
                      className="mt-4 px-4 py-2 border-none rounded-full text-base font-medium bg-red-600 text-white cursor-pointer transition-all duration-400 ease-in-out hover:scale-110 text-center"
                    >
                      Delete ID front
                    </button>
                  ) : (
                    <label
                      htmlFor="fileFrontId"
                      className="mt-4  px-4 py-2 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center"
                    >
                      Attach ID front
                    </label>
                  )}

                  {idCardBackFile ? (
                    <button
                      onClick={() => setIdCardBackFile(null)}
                      className="mt-4 px-4 py-2 border-none rounded-full text-base font-medium bg-red-600 text-white cursor-pointer transition-all duration-400 ease-in-out hover:scale-110 text-center"
                    >
                      Delete ID back
                    </button>
                  ) : (
                    <label
                      htmlFor="fileBackId"
                      className="mt-4  px-4 py-2 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center"
                    >
                      Attach ID back
                    </label>
                  )}
                </div>

                <button
                  onClick={verify}
                  disabled={isIdCardDisabled}
                  className={`mt-10 w-full px-8 py-6 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center ${isIdCardDisabled ? disabledStyle : ''}`}
                >
                  Verify
                </button>
              </div>
            )}
            {activeTab === 'studentcard' && (
              <div className="tab_content w-full">
                <input
                  type="file"
                  id="fileFrontStudentCard"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => wrapperSendFile(e, (e) => setStudentCardFrontFile(e.target.files[0]))}
                />
                <input
                  type="file"
                  id="fileBackStudentCard"
                  className="hidden"
                  accept="image/*"
                  onChange={(e) => wrapperSendFile(e, (e) => setStudentCardBackFile(e.target.files[0]))}
                />
                <div className="flex justify-center gap-4">
                  {studentCardFrontFile ? (
                    <button
                      onClick={() => setStudentCardFrontFile(null)}
                      className="mt-4 px-4 py-2 border-none rounded-full text-base font-medium bg-red-600 text-white cursor-pointer transition-all duration-400 ease-in-out hover:scale-110 text-center"
                    >
                      Delete Student card front
                    </button>
                  ) : (
                    <label
                      htmlFor="fileFrontStudentCard"
                      className="mt-4  px-4 py-2 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center"
                    >
                      Attach Student card front
                    </label>
                  )}

                  {studentCardBackFile ? (
                    <button
                      onClick={() => setStudentCardBackFile(null)}
                      className="mt-4 px-4 py-2 border-none rounded-full text-base font-medium bg-red-600 text-white cursor-pointer transition-all duration-400 ease-in-out hover:scale-110 text-center"
                    >
                      Delete Student card back
                    </button>
                  ) : (
                    <label
                      htmlFor="fileBackStudentCard"
                      className="mt-4  px-4 py-2 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center"
                    >
                      Attach Student card back
                    </label>
                  )}
                </div>

                <button
                  onClick={verify}
                  disabled={isStudentCardDisabled}
                  className={`mt-10 w-full px-8 py-6 border-none rounded-full text-base font-medium bg-[#77ED91] text-[#0D0D0D] cursor-pointer transition-all duration-400 ease-in-out hover:bg-[white] hover:scale-110 text-center ${isStudentCardDisabled ? disabledStyle : ''}`}
                >
                  Verify
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VerifyModal;
